// サイト内から参照する外部リンクの唯一の定義場所。
// 同じ URL を複数のページに書かないこと。
export const INQUIRY_FORM_URL =
  "https://share.hsforms.com/1kclB_gOmSuezIFa1u2PWHwe4idn";

export const FAQ_URL =
  "https://readable-pdf.notion.site/3ea2acf75d7245428e9d77e2192cf5cb";

export const CHROME_EXTENSION_URL =
  "https://readable-pdf.notion.site/Chrome-2ae48922477280c69dbbe7d52f9a28af";

export const SAMPLE_PDF_URL = "/test.pdf";

/**
 * ナビゲーションの 1 項目。
 * アプリ内リンクなら to、外部リンクなら href のどちらか一方だけを持つ。
 */
export type SiteLink =
  | { label: string; to: string; href?: never }
  | { label: string; to?: never; href: string };

// 翻訳済み PDF の配信元。ファイルパスから URL を組み立てるのはここだけにする。
const FILE_BASE_URL = process.env.REACT_APP_READABLE_FILE_URL;

/** 1 回の翻訳で生成される PDF 一式。3 つは必ずそろって返ってくる。 */
export interface TranslatedFiles {
  ja: string;
  alt: string;
  print: string;
}

/**
 * 翻訳済みファイルの URL を返す。
 * 配信元が未設定のまま "undefined/xxx.pdf" を開きにいっても原因が分からないので、
 * 黙って進めずにここで落とす。
 */
export const translatedFileUrl = (filepath: string): string => {
  if (!FILE_BASE_URL) {
    throw new Error("REACT_APP_READABLE_FILE_URL is not set");
  }

  return FILE_BASE_URL + filepath;
};
